module.exports = __webpack_public_path__ + "img/fail.6580673f.svg";